import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { BreakEvenListComponent } from './break-even-list.component';

@NgModule({
    providers: [],
    declarations: [
        BreakEvenListComponent,
    ],
    imports: [
        CommonModule,
        MatProgressBarModule,
        MatTableModule,
        TranslateModule,
        MatSortModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
    ],
    exports: [
        BreakEvenListComponent,
    ],
})
export class BreakEvenListModule {
}
